import { resetAgentStores } from '@atlassian/conversation-assistant-agent/controllers/agents';
import { addSentryBreadcrumb } from '@atlassian/conversation-assistant-instrumentation/services/sentry';
import { createInitialChatState } from '@atlassian/conversation-assistant-store/controllers/chat';

import { abortRequests } from './abortRequests';
import type { ChatStoreAction } from './types';

export const resetChatStoresForSite =
	({ siteId }: { siteId: string }): ChatStoreAction<Promise<void>> =>
	async ({ setState, dispatch }, { setConversationError }) => {
		addSentryBreadcrumb('resetChatStoresForSite: clearing chat state for the new site');

		await dispatch(abortRequests());

		setState({
			...createInitialChatState(),
			liveChatMetadata: null,
			hydratedSiteId: siteId,
		});

		setConversationError(undefined);

		resetAgentStores();
	};
